<template>
  <div
    class="flex items-center justify-center w-full h-screen text-center"
    id="app"
  >
    <div
      class="upload-zone"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <input
        type="file"
        name="fields[assetsFieldHandle][]"
        id="assetsFieldHandle"
        class="upload-zone-input"
        @change="onChange"
        ref="file"
        :accept="validMimeTypesAsString"
      />

      <label
        for="assetsFieldHandle"
        class="Fuell-Text u-pointer mb-0"
      >
        {{text}}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'upload-zone',
  props: {
    validMimeTypes: {
      type: Array,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      fileList: [],
      errorMessage: null
    }
  },
  computed: {
    validMimeTypesAsString () {
      return this.validMimeTypes.join(',')
    }
  },
  methods: {
    onChange () {
      this.fileList = [...this.$refs.file.files]
      this.$emit('selected', this.fileList[0])
    },
    remove (i) {
      this.fileList.splice(i, 1)
    },
    dragover (event) {
      this.resetErrorMessage()
      event.preventDefault()
      event.currentTarget.classList.add('active')
    },
    dragleave (event) {
      event.currentTarget.classList.remove('active')
    },
    drop (event) {
      event.preventDefault()
      const files = event.dataTransfer.files
      const file = files[0]
      const mime = file.type
      if (!this.validMimeTypes || this.validMimeTypes.indexOf(mime) >= 0) {
        this.$refs.file.files = event.dataTransfer.files
        this.onChange()
      } else {
        this.setInvalidFileTypeErrorMessage()
      }
      event.currentTarget.classList.remove('active')
    },
    resetErrorMessage () {
      this.errorMessage = ''
    },
    setInvalidFileTypeErrorMessage () {
      this.errorMessage = 'upload.invalid_filetype'
    }
  }
}
</script>

<style>
.upload-zone {
  padding: 25px;
  margin-top: 10px;
  background-color: var(--gray-lighter);
  border-radius: 10px;
  width: 100%;
}
.upload-zone.active {
  background-color: var(--blue-action-1-active);
}
.upload-zone.active .Fuell-Text {
  color: white;
}
.upload-zone-input {
  width: 0;
  height: 0;
  opacity: 0;
}
</style>
